// Module
var code = "<template class=\"a-form\" data-parent-id.bind=\"parentId\"> <slot></slot> </template> ";
// Exports
export default code;